import { useNavigate } from "react-router-dom";

import { AssetManagerSingleCardTemplate } from "../../../../../templates";
import { EditForm } from "../../../../shared";
import { useEdit } from "./useEdit";

export const Edit = (): JSX.Element => {
  const navigate = useNavigate();
  const { pageTitle, dataIsLoading, userDetails, userUuid, roles, rolesInfo, userSettingsRoute } = useEdit();

  return (
    <div>
      {!dataIsLoading && (
        <AssetManagerSingleCardTemplate
          activeElement="Settings"
          pageTitle={pageTitle}
          handleBackClick={() => navigate(userSettingsRoute)}
          backButtonText="Back to users"
        >
          {userDetails && (
            <EditForm
              userUuid={userUuid}
              defaultRoleValue={userDetails.role}
              defaultActiveValue={userDetails.active}
              firstName={userDetails.user.firstName}
              lastName={userDetails.user.lastName}
              email={userDetails.user.email}
              roles={roles}
              rolesInfo={rolesInfo}
              rowVersion={userDetails.rowVersion}
              userSettingsRoute={userSettingsRoute}
            />
          )}
        </AssetManagerSingleCardTemplate>
      )}
    </div>
  );
};
